import { Tag } from "@chakra-ui/react";
import { ReactNode } from "react";

export const FilterTag: React.FC<{
  children: ReactNode;
  onClose: () => void;
}> = ({ children, onClose }) => {
  return (
    <Tag.Root m={1} py={1} fontSize="xs">
      <Tag.Label>{children}</Tag.Label>
      <Tag.EndElement>
        <Tag.CloseTrigger onClick={onClose} />
      </Tag.EndElement>
    </Tag.Root>
  );
};
